import React, { useState } from 'react';
import { ReportModalWrapper, Title, SubTitle } from './style';
import Reasons from '../../../models/local/Report/Reasons';
import Radio from 'reusecore/src/elements/Radio';
import Button from 'reusecore/src/elements/Button';
import { useMutation } from '@apollo/client';
import { ADD_REPORT } from '@core/ui/graphql/Mutations';
import { useTranslation } from 'next-i18next';

const ReportModal = ({ ads, userId, ...props }) => {
  const { t } = useTranslation();

  const [email, setEmail] = useState(null);
  const [extra, setExtra] = useState('');
  const [reason, setReason] = useState('fraud');
  const [loading, setLoading] = useState(false);
  const [reported, setReported] = useState(false);
  const [error, setError] = useState(false);

  const reasonsLocale = Reasons();

  const getTitle = ads => {
    if (ads.title) {
      const length = ads.title.length;
      const maxLength = 25;
      const title = ads.title.substring(0, maxLength);
      if (length > maxLength) {
        return title + '...';
      }
      return title;
    }
    return '';
  };

  const [reportMutation] = useMutation(ADD_REPORT, {
    variables: {
      report: {
        from: email,
        userId: userId || null,
        adsTitle: ads.title,
        sid: ads.sid,
        reason,
        extra,
      },
    },
  });

  const submit = async () => {
    try {
      setLoading(true);
      if (userId) {
      }
      await reportMutation();
      setReported(true);
    } catch (e) {
      setError(t('adsView.view.report.error'));
    }
    setLoading(false);
  };

  return (
    <ReportModalWrapper>
      <Title>
        {t('adsView.view.report.modal.title')} <strong>{getTitle(ads)}</strong>
      </Title>
      {reported ? (
        <p style={{ textAlign: 'center' }}>
          {t('adsView.view.report.modal.success')} <br />
          {t('adsView.view.report.modal.success2')}
        </p>
      ) : (
        <div>
          {!userId && (
            <div style={{ margin: '10px 0' }}>
              <SubTitle>Votre E-Mail</SubTitle>
              <input
                value={email}
                required={true}
                type="text"
                placeholder={t('adsView.view.report.modal.mail')}
                onChange={e => setEmail(e.currentTarget.value)}
              />
            </div>
          )}
          <div
            style={{
              margin: '10px 0',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <SubTitle>{t('adsView.view.report.modal.reason')}</SubTitle>
            {reasonsLocale.map(r => (
              <Radio
                style={{ margin: '0 10px' }}
                checked={reason === r.value}
                key={r.value}
                value={r.value}
                labelText={r.label}
                onClick={() => setReason(r.value)}
              />
            ))}
          </div>
          <div className="compose" style={{ margin: '10px 0' }}>
            <textarea
              style={{ minWidth: '300px' }}
              value={extra}
              placeholder={t('adsView.view.report.modal.message')}
              className={'textarea compose-input'}
              onChange={e => setExtra(e.currentTarget.value)}
              required={reason === 'other'}
            />
          </div>
          {error && <p style={{ color: 'rgb(241, 82, 81)' }}>{error}</p>}
          <div style={{ margin: '10px 0', textAlign: 'left' }}>
            <Button
              className="primary"
              title={t('send')}
              onClick={submit}
              isLoading={loading}
            />
          </div>
        </div>
      )}
    </ReportModalWrapper>
  );
};
export default ReportModal;
